// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1-tf6","title":"InfoRow_title__2ifx-"};